import React, { useEffect } from 'react';
import { useNavigate, useLocation } from '@reach/router';

export const TEST_ID = {
  MAIN: 'location-moved'
};
export interface MovedProps {
  // Required for router, causes this to render which redirects
  path: string;
  movedTo: string;
}

export const Moved: React.FC<MovedProps> = props => {
  const { movedTo } = props;
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(movedTo, { replace: true });
  }, [location.search, movedTo, navigate]);
  return (
    <div data-testid={TEST_ID.MAIN}>
      The location you are looking for has moved to {movedTo}. We are
      automatically redirecting you. To avoid seeing this message in the future,
      update your bookmarks and links.
    </div>
  );
};
